import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Library } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/obligations/library')({
    staticData: {
        breadcrumb: {
            title: 'Obligations library',
        },
        ui: {
            icon: Library,
            menuDescription: 'Master obligations library',
        },
    },
    component: Outlet,
});
